export default __webpack_public_path__ + "static/media/typescript.a6305a73.svg";